import React, { Component } from "react";
import { useParams } from "react-router-dom";
import { string } from "prop-types";

import { obterOcorrenciaDetalhada } from "../../api/reinf-jt";

import OcorrenciaDetalhada from "./OcorrenciaDetalhada";
import {
  withLoader,
  loaderPropTypes
} from "../../../shared/components/loader/LoaderContext";
import {
  withMessages,
  messagePropTypes
} from "../../../shared/components/message/MessageContext";
import { ERROR } from "../../../shared/components/message/MessageType";

class OcorrenciaDetalhadaRouteComponent extends Component {
  static propTypes = {
    ...loaderPropTypes,
    ...messagePropTypes,
    id: string
  };

  state = {
    ocorrencia: null
  };

  componentDidMount() {
    this.__loadOcorrencia(this.props.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.__loadOcorrencia(this.props.id);
    }
  }

  __loadOcorrencia = async id => {
    const loaderId = `load-ocorrencia-${id}`;
    this.props.setLoading(loaderId, true, this.state.ocorrencia === null);
    try {
      const ocorrencia = await obterOcorrenciaDetalhada(id);
      this.setState({ ocorrencia });
    } catch (error) {
      let errorMessage = error;
      if (error.message) {
        errorMessage = error.message;
      }
      this.props.addMessage(ERROR, errorMessage);
    } finally {
      this.props.setLoading(loaderId, false);
    }
  };

  render() {
    if (this.state.ocorrencia) {
      return <OcorrenciaDetalhada ocorrencia={this.state.ocorrencia} />;
    } else {
      return <div />;
    }
  }
}

const WrappedComponent = withMessages(withLoader(OcorrenciaDetalhadaRouteComponent));

function OcorrenciaDetalhadaRoute() {
  const { id } = useParams();
  return <WrappedComponent id={id} />;
}

export default OcorrenciaDetalhadaRoute;
